export default __webpack_public_path__ + "static/media/200.5f5f5f1d.jpg";